 
 
 
 
 
 
/**
 * The ResultsLit view allows to create foldable results widget on a map.
 *
 * @class ResultsList
 * @namespace L
 * @extends L.Foldable
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.className="tomtom-results-list"]
 * @param {String} [options.title="Results"]
 * @param {String} [options.close={text: "×"}]
 * @param {Boolean} [options.closeOnClick=true]
 * @param {Object} [options.show={text: "show"}]
 * @param {String} [options.content="Fill in the form on the left and press enter to run search."]
 */
define(['display/map', 'widgets/controls/foldable'],
    function(L) {
        'use strict';

        L.ResultsList = L.Foldable.extend({
            options: {
                className: 'tomtom-results-list',
                title: 'Results',
                close: { text: '×' },
                closeOnClick: true,
                show: { text: 'show' },
                content: 'Fill in the form on the left and press enter to run search.'
            }
        });

        return function(options) {
            return new L.ResultsList(options);
        };
    }
);



// WEBPACK FOOTER //
// ./widgets/controls/resultsList.js